var _defs, _polygon, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle4, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle5, _path32, _path33, _path34, _path35, _path36, _path37, _circle6, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle7, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYearlyimpactmobile1642795729506(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 658.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d4762;}.cls-2{fill:#ff5a5f;}.cls-3{fill:#333;}.cls-4,.cls-5{fill:none;stroke:#e2dddb;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}.cls-5{stroke-dasharray:0 10.4;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.37 624.53 131.58 623.63 215.79 620.37 300 603.74 384.21 559.44 468.42 457.46 552.63 167.06 600 0 600 627.07 0 627.07 47.37 624.53"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47.35,
    cy: 624.55,
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,664.88H21.82v-1.56l5.9-6.56a13.62,13.62,0,0,0,1.81-2.42,4,4,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.83,2.83,0,0,0-2.15-.86,3.38,3.38,0,0,0-2.52.92,3.56,3.56,0,0,0-.89,2.56H21.49A5,5,0,0,1,23,649a5.61,5.61,0,0,1,4.06-1.46,5.42,5.42,0,0,1,3.76,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5H33Z",
    transform: "translate(0 -6.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,657.6q0,3.81-1.3,5.66a4.61,4.61,0,0,1-4.06,1.85,4.66,4.66,0,0,1-4.05-1.81,9.43,9.43,0,0,1-1.36-5.41V655a9.75,9.75,0,0,1,1.3-5.59,4.67,4.67,0,0,1,4.08-1.83,4.71,4.71,0,0,1,4.06,1.77A9.37,9.37,0,0,1,46,654.79Zm-2.17-3a7.92,7.92,0,0,0-.77-4,2.65,2.65,0,0,0-2.45-1.26,2.61,2.61,0,0,0-2.42,1.26,7.75,7.75,0,0,0-.79,3.85v3.47a8.14,8.14,0,0,0,.8,4.09,2.68,2.68,0,0,0,2.44,1.31A2.61,2.61,0,0,0,43,662.1a7.73,7.73,0,0,0,.81-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.89,664.88H53.71V650.43L49.34,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.24,656.32l.87-8.5h8.74v2H66l-.52,4.65a5.55,5.55,0,0,1,2.85-.74,4.69,4.69,0,0,1,3.7,1.55,6,6,0,0,1,1.38,4.16,5.85,5.85,0,0,1-1.43,4.16,5.19,5.19,0,0,1-4,1.51,5.38,5.38,0,0,1-3.69-1.25,5.05,5.05,0,0,1-1.63-3.47h2.05a3.45,3.45,0,0,0,1,2.21,3.2,3.2,0,0,0,2.22.74,2.94,2.94,0,0,0,2.38-1,4.3,4.3,0,0,0,.86-2.84,4,4,0,0,0-.93-2.75,3.19,3.19,0,0,0-2.48-1,3.6,3.6,0,0,0-2.23.62l-.57.47Z",
    transform: "translate(0 -6.76)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.06,484.07l1-10.11h9.63v3.31H31.22l-.36,4.26a4.12,4.12,0,0,1,2.31-.75,4.49,4.49,0,0,1,3.8,1.75,8.1,8.1,0,0,1,1.33,5,7.09,7.09,0,0,1-1.59,4.82,5.29,5.29,0,0,1-4.24,1.84,5.9,5.9,0,0,1-2.91-.75,5.52,5.52,0,0,1-2.11-2.07,6,6,0,0,1-.79-3h3.83a3.64,3.64,0,0,0,.62,1.93,1.65,1.65,0,0,0,2.81-.24,5.68,5.68,0,0,0,.52-2.75,4.44,4.44,0,0,0-.62-2.6,2,2,0,0,0-1.74-.88,2,2,0,0,0-1.7.76l-.24.34Z",
    transform: "translate(0 -6.76)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.39,485.63A11.14,11.14,0,0,1,50.9,492a5.28,5.28,0,0,1-8.52.06,10.71,10.71,0,0,1-1.55-6.09v-3.76a11.11,11.11,0,0,1,1.49-6.3,5.31,5.31,0,0,1,8.56,0A10.91,10.91,0,0,1,52.39,482Zm-3.88-4a10.18,10.18,0,0,0-.46-3.53,1.55,1.55,0,0,0-1.45-1.17q-1.85,0-1.92,4.3v5a10.07,10.07,0,0,0,.48,3.58,1.56,1.56,0,0,0,1.47,1.17,1.5,1.5,0,0,0,1.4-1.1,9.75,9.75,0,0,0,.48-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.9,486.18l-1.59,2v5.68h-4V474h4v8.68l1.27-2.15L64.29,474h4.92l-5.7,8.75,5.8,11.15H64.54Z",
    transform: "translate(0 -6.76)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 131.59,
    cy: 623.67,
    r: 7.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.23,664.88H106.05v-1.56l5.91-6.56a14.14,14.14,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.37,3.37,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.16a5,5,0,0,1,1.51-3.8,5.63,5.63,0,0,1,4.06-1.46,5.45,5.45,0,0,1,3.77,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5h8.56Z",
    transform: "translate(0 -6.76)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.23,657.6q0,3.81-1.3,5.66a5.41,5.41,0,0,1-8.11,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,5.49,5.49,0,0,1,8.13-.06,9.29,9.29,0,0,1,1.34,5.44Zm-2.17-3a8,8,0,0,0-.77-4,2.67,2.67,0,0,0-2.45-1.26,2.63,2.63,0,0,0-2.43,1.26,7.65,7.65,0,0,0-.78,3.85v3.47a8.14,8.14,0,0,0,.8,4.09,2.68,2.68,0,0,0,2.43,1.31,2.62,2.62,0,0,0,2.39-1.24,7.73,7.73,0,0,0,.81-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.13,664.88H138V650.43L133.58,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155,647.8v1.84h-.4a5.78,5.78,0,0,0-4,1.5,6.23,6.23,0,0,0-1.73,4.09,4.62,4.62,0,0,1,3.68-1.54,4.4,4.4,0,0,1,3.55,1.57,6.89,6.89,0,0,1-.1,8.27,4.93,4.93,0,0,1-3.85,1.58,4.84,4.84,0,0,1-4-1.88,7.42,7.42,0,0,1-1.53-4.84v-.84q0-4.71,2-7.2a7.39,7.39,0,0,1,6-2.55Zm-2.85,7.69a3.64,3.64,0,0,0-3.35,2.35v.79a5.61,5.61,0,0,0,1,3.4,2.84,2.84,0,0,0,2.37,1.29,2.76,2.76,0,0,0,2.3-1.08,5.16,5.16,0,0,0,0-5.66A2.72,2.72,0,0,0,152.14,655.49Z",
    transform: "translate(0 -6.76)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.34,492.86h-3.89v-15.2l-3.78,1.46V475.9l7.26-3h.41Z",
    transform: "translate(0 -6.76)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.55,484.63a11.13,11.13,0,0,1-1.5,6.32,5.28,5.28,0,0,1-8.52.06,10.87,10.87,0,0,1-1.55-6.09v-3.76a11.19,11.19,0,0,1,1.49-6.3,5.31,5.31,0,0,1,8.56,0,10.91,10.91,0,0,1,1.52,6.17Zm-3.88-4a10.14,10.14,0,0,0-.47-3.53,1.55,1.55,0,0,0-1.45-1.17q-1.84,0-1.91,4.3v5a10.34,10.34,0,0,0,.47,3.58,1.56,1.56,0,0,0,1.47,1.17,1.48,1.48,0,0,0,1.4-1.1,9.47,9.47,0,0,0,.49-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.71,484.63a11.22,11.22,0,0,1-1.49,6.32,5.28,5.28,0,0,1-8.52.06,10.71,10.71,0,0,1-1.55-6.09v-3.76a11.11,11.11,0,0,1,1.49-6.3,5.31,5.31,0,0,1,8.56,0,11,11,0,0,1,1.51,6.17Zm-3.88-4a10.18,10.18,0,0,0-.46-3.53,1.55,1.55,0,0,0-1.45-1.17q-1.84,0-1.92,4.3v5a10.34,10.34,0,0,0,.47,3.58,1.58,1.58,0,0,0,1.47,1.17,1.5,1.5,0,0,0,1.41-1.1,9.75,9.75,0,0,0,.48-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.22,485.18l-1.59,2v5.68h-4V473h4v8.68l1.27-2.15,3.71-6.53h4.92l-5.7,8.75,5.8,11.15h-4.78Z",
    transform: "translate(0 -6.76)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 215.83,
    cy: 620.07,
    r: 7.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.47,664.88H190.29v-1.56l5.91-6.56a14.14,14.14,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.34,3.34,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56H190a5,5,0,0,1,1.52-3.8,5.63,5.63,0,0,1,4.06-1.46,5.4,5.4,0,0,1,3.76,1.25,4.27,4.27,0,0,1,1.39,3.32c0,1.68-1.08,3.68-3.22,6l-4.57,5h8.57Z",
    transform: "translate(0 -6.76)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.47,657.6a10,10,0,0,1-1.3,5.66,5.41,5.41,0,0,1-8.11,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,4.65,4.65,0,0,1,4.08-1.83,4.7,4.7,0,0,1,4,1.77c.87,1.17,1.31,3,1.34,5.44Zm-2.17-3a8,8,0,0,0-.77-4,2.68,2.68,0,0,0-2.45-1.26,2.63,2.63,0,0,0-2.43,1.26,7.75,7.75,0,0,0-.79,3.85v3.47a8,8,0,0,0,.81,4.09,2.66,2.66,0,0,0,2.43,1.31,2.61,2.61,0,0,0,2.38-1.24,7.72,7.72,0,0,0,.82-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.37,664.88h-2.18V650.43L217.82,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.74,649l-7.07,15.84H232.4l7-15.28H230.2v-1.78h11.54Z",
    transform: "translate(0 -6.76)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.5,477.15h1.87a1.74,1.74,0,0,0,1.57-.75,3.55,3.55,0,0,0,.5-2,3,3,0,0,0-.51-1.85,1.66,1.66,0,0,0-1.38-.66,1.62,1.62,0,0,0-1.32.63,2.4,2.4,0,0,0-.51,1.58h-3.87a5.42,5.42,0,0,1,.72-2.79,5.07,5.07,0,0,1,2-1.94,6.59,6.59,0,0,1,7.17.82,5.53,5.53,0,0,1,1.56,4.16,4.92,4.92,0,0,1-2.56,4.28,4.25,4.25,0,0,1,2.1,1.8,6.2,6.2,0,0,1-1,7.1,6.19,6.19,0,0,1-4.43,1.6,5.64,5.64,0,0,1-4.15-1.58,5.56,5.56,0,0,1-1.6-4.15h3.87a2.85,2.85,0,0,0,.56,1.79,1.74,1.74,0,0,0,1.42.72,1.89,1.89,0,0,0,1.58-.73,3.1,3.1,0,0,0,.58-2c0-2-.76-3-2.28-3h-1.9Z",
    transform: "translate(0 -6.76)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.79,480.63a11.13,11.13,0,0,1-1.5,6.32,5.28,5.28,0,0,1-8.52.06,10.79,10.79,0,0,1-1.55-6.09v-3.76a11.19,11.19,0,0,1,1.49-6.3,5.31,5.31,0,0,1,8.56,0,11,11,0,0,1,1.52,6.17Zm-3.89-4a10.18,10.18,0,0,0-.46-3.53A1.55,1.55,0,0,0,208,471.9q-1.85,0-1.91,4.3v5a10.11,10.11,0,0,0,.47,3.58,1.56,1.56,0,0,0,1.47,1.17,1.49,1.49,0,0,0,1.4-1.1,9.75,9.75,0,0,0,.48-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228,480.63a11.13,11.13,0,0,1-1.5,6.32,5.27,5.27,0,0,1-8.51.06,10.79,10.79,0,0,1-1.56-6.09v-3.76a11.19,11.19,0,0,1,1.49-6.3,5.31,5.31,0,0,1,8.56,0A10.91,10.91,0,0,1,228,477Zm-3.88-4a10.14,10.14,0,0,0-.47-3.53,1.55,1.55,0,0,0-1.45-1.17q-1.85,0-1.91,4.3v5a10.34,10.34,0,0,0,.47,3.58,1.58,1.58,0,0,0,1.47,1.17,1.48,1.48,0,0,0,1.4-1.1,9.47,9.47,0,0,0,.49-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.45,481.18l-1.58,2v5.68h-4V469h4v8.68l1.27-2.15,3.7-6.53h4.93l-5.7,8.75,5.79,11.15h-4.77Z",
    transform: "translate(0 -6.76)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.06,
    cy: 603.98,
    r: 7.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M285.64,664.88H274.46v-1.56l5.91-6.56a13.62,13.62,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.37,3.37,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.16a5,5,0,0,1,1.51-3.8,5.65,5.65,0,0,1,4.06-1.46,5.45,5.45,0,0,1,3.77,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5h8.56Z",
    transform: "translate(0 -6.76)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.64,657.6q0,3.81-1.3,5.66a5.41,5.41,0,0,1-8.11,0,9.43,9.43,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,5.49,5.49,0,0,1,8.13-.06,9.29,9.29,0,0,1,1.34,5.44Zm-2.17-3a8,8,0,0,0-.77-4,2.67,2.67,0,0,0-2.45-1.26,2.63,2.63,0,0,0-2.43,1.26,7.76,7.76,0,0,0-.78,3.85v3.47a8.14,8.14,0,0,0,.8,4.09,2.68,2.68,0,0,0,2.43,1.31,2.62,2.62,0,0,0,2.39-1.24,7.73,7.73,0,0,0,.81-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.54,664.88h-2.18V650.43L302,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.24,652.27a3.94,3.94,0,0,1-.67,2.27,4.54,4.54,0,0,1-1.82,1.56,4.83,4.83,0,0,1,2.11,1.68,4.19,4.19,0,0,1,.78,2.49,4.47,4.47,0,0,1-1.49,3.53,6.58,6.58,0,0,1-7.88,0,4.49,4.49,0,0,1-1.48-3.53,4.35,4.35,0,0,1,.75-2.49,4.76,4.76,0,0,1,2.1-1.69,4.42,4.42,0,0,1-1.8-1.56,4.07,4.07,0,0,1-.65-2.26,4.4,4.4,0,0,1,1.38-3.42,5.85,5.85,0,0,1,7.28,0A4.37,4.37,0,0,1,325.24,652.27Zm-1.77,8a3.15,3.15,0,0,0-.91-2.34,3.24,3.24,0,0,0-5.6,2.34,3,3,0,0,0,.86,2.28,3.27,3.27,0,0,0,2.39.83,3.35,3.35,0,0,0,2.4-.83A3.05,3.05,0,0,0,323.47,660.23Zm-3.26-10.87a2.8,2.8,0,0,0-2.06.79,3.3,3.3,0,0,0,0,4.26,2.8,2.8,0,0,0,2.08.8,2.76,2.76,0,0,0,2.08-.8,3.23,3.23,0,0,0,0-4.23A2.8,2.8,0,0,0,320.21,649.36Z",
    transform: "translate(0 -6.76)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281,473.36h-3.88v-15.2l-3.79,1.46v-3.23l7.26-3H281Z",
    transform: "translate(0 -6.76)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287,471.39a2,2,0,0,1,.62-1.53,2.25,2.25,0,0,1,1.62-.6,2.32,2.32,0,0,1,1.62.59,2,2,0,0,1,.64,1.54,2,2,0,0,1-.65,1.54,2.31,2.31,0,0,1-1.61.58,2.27,2.27,0,0,1-1.6-.59A2,2,0,0,1,287,471.39Z",
    transform: "translate(0 -6.76)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.2,461.64h1.87a1.76,1.76,0,0,0,1.57-.74,3.55,3.55,0,0,0,.5-2,3,3,0,0,0-.51-1.86,1.66,1.66,0,0,0-1.38-.66,1.63,1.63,0,0,0-1.32.63,2.45,2.45,0,0,0-.51,1.59h-3.87a5.48,5.48,0,0,1,.72-2.8,5,5,0,0,1,2-1.93,6.59,6.59,0,0,1,7.17.82,5.51,5.51,0,0,1,1.56,4.15,4.92,4.92,0,0,1-2.56,4.28,4.22,4.22,0,0,1,2.1,1.81,5.61,5.61,0,0,1,.69,2.84,5.55,5.55,0,0,1-1.69,4.25,6.15,6.15,0,0,1-4.43,1.6,5.6,5.6,0,0,1-4.15-1.58,5.54,5.54,0,0,1-1.6-4.15h3.87a2.85,2.85,0,0,0,.56,1.79,1.73,1.73,0,0,0,1.43.73,1.89,1.89,0,0,0,1.57-.74,3.08,3.08,0,0,0,.59-2c0-2-.77-2.94-2.29-2.95h-1.9Z",
    transform: "translate(0 -6.76)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.47,453.45l3.76,14.4,3.75-14.4h5.25v19.91h-4V468l.37-8.3-4,13.69h-2.73l-4-13.69.37,8.3v5.39h-4V453.45Z",
    transform: "translate(0 -6.76)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 384.3,
    cy: 559.48,
    r: 7.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.94,664.88H358.76v-1.56l5.91-6.56a13.62,13.62,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.37,3.37,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.16A5,5,0,0,1,360,649a5.65,5.65,0,0,1,4.06-1.46,5.45,5.45,0,0,1,3.77,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5h8.56Z",
    transform: "translate(0 -6.76)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.94,657.6q0,3.81-1.3,5.66a5.41,5.41,0,0,1-8.11,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,5.49,5.49,0,0,1,8.13-.06,9.29,9.29,0,0,1,1.34,5.44Zm-2.17-3a8,8,0,0,0-.77-4,2.67,2.67,0,0,0-2.45-1.26,2.63,2.63,0,0,0-2.43,1.26,7.76,7.76,0,0,0-.78,3.85v3.47a8.14,8.14,0,0,0,.8,4.09,2.68,2.68,0,0,0,2.43,1.31A2.62,2.62,0,0,0,380,662.1a7.73,7.73,0,0,0,.81-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.84,664.88h-2.18V650.43L386.29,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.5,657.38a5.25,5.25,0,0,1-1.62,1.3,4.39,4.39,0,0,1-2.07.49,4.58,4.58,0,0,1-2.57-.72,4.7,4.7,0,0,1-1.69-2.05,7.49,7.49,0,0,1,.05-6,4.74,4.74,0,0,1,1.84-2.1,5.23,5.23,0,0,1,2.79-.73,4.76,4.76,0,0,1,4,1.89,8.25,8.25,0,0,1,1.46,5.17v.63c0,3.32-.65,5.74-2,7.27s-3.29,2.31-5.94,2.35h-.42v-1.84h.46a5.16,5.16,0,0,0,5.69-5.67Zm-3.34,0a3.31,3.31,0,0,0,2-.67,3.82,3.82,0,0,0,1.34-1.65v-.87a6,6,0,0,0-.92-3.47,2.84,2.84,0,0,0-4.64-.24,4.52,4.52,0,0,0-.87,2.89,4.71,4.71,0,0,0,.84,2.88A2.67,2.67,0,0,0,404.16,657.38Z",
    transform: "translate(0 -6.76)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.1,421h1.69v3.21H378.1v4.31h-3.87v-4.31h-6.59l-.18-2.5,6.76-13.1h3.88Zm-6.88,0h3v-6.66l-.08.15Z",
    transform: "translate(0 -6.76)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.61,408.63l3.76,14.4,3.75-14.4h5.25v19.91h-4v-5.39l.37-8.3-4,13.69H390l-4-13.69.36,8.3v5.39h-4V408.63Z",
    transform: "translate(0 -6.76)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 468.54,
    cy: 457.28,
    r: 7.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454.18,664.88H443v-1.56l5.91-6.56a14.14,14.14,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.34,3.34,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.17a5,5,0,0,1,1.52-3.8,5.63,5.63,0,0,1,4.06-1.46,5.4,5.4,0,0,1,3.76,1.25,4.27,4.27,0,0,1,1.39,3.32c0,1.68-1.08,3.68-3.22,6l-4.57,5h8.57Z",
    transform: "translate(0 -6.76)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.18,657.6a10,10,0,0,1-1.3,5.66,5.41,5.41,0,0,1-8.11,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,4.65,4.65,0,0,1,4.08-1.83,4.7,4.7,0,0,1,4,1.77c.87,1.17,1.31,3,1.34,5.44Zm-2.17-3a7.9,7.9,0,0,0-.78-4,3,3,0,0,0-4.87,0,7.75,7.75,0,0,0-.79,3.85v3.47a8,8,0,0,0,.81,4.09,2.66,2.66,0,0,0,2.43,1.31,2.61,2.61,0,0,0,2.38-1.24,7.83,7.83,0,0,0,.82-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481.13,664.88H470v-1.56l5.91-6.56a14.14,14.14,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.37,3.37,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.16a5,5,0,0,1,1.51-3.8,5.63,5.63,0,0,1,4.06-1.46,5.45,5.45,0,0,1,3.77,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5h8.56Z",
    transform: "translate(0 -6.76)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494.13,657.6q0,3.81-1.3,5.66a5.41,5.41,0,0,1-8.11,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,5.49,5.49,0,0,1,8.13-.06,9.29,9.29,0,0,1,1.34,5.44Zm-2.17-3a8,8,0,0,0-.77-4,2.67,2.67,0,0,0-2.45-1.26,2.63,2.63,0,0,0-2.43,1.26,7.76,7.76,0,0,0-.78,3.85v3.47a8.14,8.14,0,0,0,.8,4.09,2.68,2.68,0,0,0,2.43,1.31,2.62,2.62,0,0,0,2.39-1.24,7.73,7.73,0,0,0,.81-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453.57,326.42h-3.88V311.21l-3.79,1.47v-3.23l7.26-3h.41Z",
    transform: "translate(0 -6.76)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.79,318.18a11.13,11.13,0,0,1-1.5,6.32,5.28,5.28,0,0,1-8.52.06,10.75,10.75,0,0,1-1.55-6.09v-3.76a11.13,11.13,0,0,1,1.49-6.29,5.31,5.31,0,0,1,8.56,0,11,11,0,0,1,1.52,6.16Zm-3.89-4a10.18,10.18,0,0,0-.46-3.53,1.55,1.55,0,0,0-1.45-1.17c-1.23,0-1.87,1.43-1.92,4.31v5a10,10,0,0,0,.48,3.58,1.57,1.57,0,0,0,1.47,1.18,1.51,1.51,0,0,0,1.4-1.1,9.83,9.83,0,0,0,.48-3.37Z",
    transform: "translate(0 -6.76)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478.93,306.51l3.76,14.4,3.75-14.4h5.25v19.91h-4V321l.37-8.3-4,13.69h-2.74l-4-13.69.37,8.3v5.39h-4V306.51Z",
    transform: "translate(0 -6.76)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 552.77,
    cy: 167.06,
    r: 7.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M538.42,664.88H527.24v-1.56l5.91-6.56a14.7,14.7,0,0,0,1.81-2.42,4.07,4.07,0,0,0,.49-1.93,3,3,0,0,0-.8-2.19,2.84,2.84,0,0,0-2.16-.86,3.34,3.34,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.17a5,5,0,0,1,1.52-3.8,5.61,5.61,0,0,1,4.06-1.46,5.4,5.4,0,0,1,3.76,1.25,4.26,4.26,0,0,1,1.38,3.32q0,2.52-3.21,6l-4.57,5h8.57Z",
    transform: "translate(0 -6.76)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M551.42,657.6a9.87,9.87,0,0,1-1.31,5.66,5.4,5.4,0,0,1-8.1,0,9.35,9.35,0,0,1-1.36-5.41V655a9.67,9.67,0,0,1,1.3-5.59,4.65,4.65,0,0,1,4.08-1.83,4.7,4.7,0,0,1,4.05,1.77c.87,1.17,1.31,3,1.34,5.44Zm-2.17-3a7.9,7.9,0,0,0-.78-4,3,3,0,0,0-4.87,0,7.75,7.75,0,0,0-.79,3.85v3.47a8,8,0,0,0,.81,4.09,2.66,2.66,0,0,0,2.43,1.31,2.61,2.61,0,0,0,2.38-1.24,7.83,7.83,0,0,0,.82-3.91Z",
    transform: "translate(0 -6.76)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565.37,664.88H554.19v-1.56l5.91-6.56a14.14,14.14,0,0,0,1.81-2.42,4.08,4.08,0,0,0,.5-1.93,3.06,3.06,0,0,0-.81-2.19,2.84,2.84,0,0,0-2.16-.86,3.35,3.35,0,0,0-2.51.92,3.52,3.52,0,0,0-.9,2.56h-2.17a5,5,0,0,1,1.52-3.8,5.63,5.63,0,0,1,4.06-1.46,5.4,5.4,0,0,1,3.76,1.25,4.23,4.23,0,0,1,1.39,3.32q0,2.52-3.21,6l-4.57,5h8.56Z",
    transform: "translate(0 -6.76)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.79,664.88h-2.18V650.43L568.24,652v-2l6.21-2.34h.34Z",
    transform: "translate(0 -6.76)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M529.87,35.72H518.14V33l5.38-6.85a14.27,14.27,0,0,0,1.51-2.5,4.88,4.88,0,0,0,.49-2.06,4,4,0,0,0-.46-2.07,1.47,1.47,0,0,0-1.32-.76,1.71,1.71,0,0,0-1.5.88,4.58,4.58,0,0,0-.55,2.46h-3.88a7.33,7.33,0,0,1,.76-3.35,5.61,5.61,0,0,1,2.13-2.36,5.82,5.82,0,0,1,3.11-.84A5.57,5.57,0,0,1,527.94,17a5.65,5.65,0,0,1,1.47,4.18,8,8,0,0,1-.81,3.41,20.78,20.78,0,0,1-3,4.26l-2.55,3.65h6.77Z",
    transform: "translate(0 -6.76)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.74,24h1.88a1.73,1.73,0,0,0,1.56-.74,3.47,3.47,0,0,0,.5-2,3,3,0,0,0-.51-1.85,1.72,1.72,0,0,0-2.69,0A2.4,2.4,0,0,0,536,21h-3.87a5.48,5.48,0,0,1,.72-2.8,5,5,0,0,1,2-1.93,6.59,6.59,0,0,1,7.17.82,5.53,5.53,0,0,1,1.56,4.16,4.7,4.7,0,0,1-.7,2.5A4.79,4.79,0,0,1,541,25.49a4.32,4.32,0,0,1,2.1,1.81,5.61,5.61,0,0,1,.69,2.84,5.58,5.58,0,0,1-1.68,4.25,6.19,6.19,0,0,1-4.44,1.6,5.43,5.43,0,0,1-5.74-5.72h3.87a2.81,2.81,0,0,0,.56,1.79,1.71,1.71,0,0,0,1.42.72,1.89,1.89,0,0,0,1.58-.74,3.14,3.14,0,0,0,.58-2c0-2-.76-2.94-2.28-2.95h-1.91Z",
    transform: "translate(0 -6.76)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.89,33.75a2,2,0,0,1,.62-1.53,2.22,2.22,0,0,1,1.62-.6,2.3,2.3,0,0,1,1.61.59,2,2,0,0,1,.65,1.54,2,2,0,0,1-.65,1.54,2.33,2.33,0,0,1-1.61.58,2.25,2.25,0,0,1-1.61-.59A2,2,0,0,1,546.89,33.75Z",
    transform: "translate(0 -6.76)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555,25.93l1-10.12h9.64v3.31h-6.47l-.35,4.27a4.12,4.12,0,0,1,2.31-.75,4.46,4.46,0,0,1,3.79,1.75,8,8,0,0,1,1.34,4.95,7.09,7.09,0,0,1-1.59,4.82A5.33,5.33,0,0,1,560.42,36a5.83,5.83,0,0,1-2.91-.74,5.52,5.52,0,0,1-2.11-2.07,6,6,0,0,1-.79-3h3.83a3.56,3.56,0,0,0,.62,1.93,1.65,1.65,0,0,0,2.81-.24,5.73,5.73,0,0,0,.52-2.76,4.5,4.5,0,0,0-.62-2.59,2,2,0,0,0-1.74-.88,2.06,2.06,0,0,0-1.7.75l-.25.34Z",
    transform: "translate(0 -6.76)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.33,15.81l3.76,14.4,3.74-14.4h5.25V35.72h-4V30.33l.37-8.29-4,13.68h-2.73l-4-13.68.37,8.29v5.39h-4V15.81Z",
    transform: "translate(0 -6.76)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.35,
    y1: 499.78,
    x2: 47.35,
    y2: 499.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.35,
    y1: 510.18,
    x2: 47.35,
    y2: 619.35
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.35,
    y1: 624.55,
    x2: 47.35,
    y2: 624.55
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 131.59,
    y1: 498.91,
    x2: 131.59,
    y2: 498.91
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 131.59,
    y1: 509.3,
    x2: 131.59,
    y2: 618.47
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 131.59,
    y1: 623.67,
    x2: 131.59,
    y2: 623.67
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 215.83,
    y1: 495.29,
    x2: 215.83,
    y2: 495.29
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 215.83,
    y1: 505.69,
    x2: 215.83,
    y2: 614.86
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 215.83,
    y1: 620.06,
    x2: 215.83,
    y2: 620.06
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 300,
    y1: 479.22,
    x2: 300,
    y2: 479.22
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300,
    y1: 489.61,
    x2: 300,
    y2: 598.78
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 300,
    y1: 603.98,
    x2: 300,
    y2: 603.98
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 384.3,
    y1: 434.72,
    x2: 384.3,
    y2: 434.72
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 384.3,
    y1: 445.12,
    x2: 384.3,
    y2: 554.29
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 384.3,
    y1: 559.48,
    x2: 384.3,
    y2: 559.48
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 468.54,
    y1: 332.51,
    x2: 468.54,
    y2: 332.51
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 468.54,
    y1: 342.91,
    x2: 468.54,
    y2: 452.08
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 468.54,
    y1: 457.28,
    x2: 468.54,
    y2: 457.28
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 552.77,
    y1: 42.3,
    x2: 552.77,
    y2: 42.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 552.77,
    y1: 52.7,
    x2: 552.77,
    y2: 161.87
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 552.77,
    y1: 167.06,
    x2: 552.77,
    y2: 167.06
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearlyimpactmobile1642795729506);
export default __webpack_public_path__ + "static/media/yearlyimpactmobile-1642795729506.54e6fbd75322742b3a71ed3f28d1e56a.svg";
export { ForwardRef as ReactComponent };